export default __webpack_public_path__ + "static/media/tinyImg6.d959aef8.png";